module.exports = __webpack_public_path__ + "img/connected-radio-logo.516640be.svg";